import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  const [state, setState] = useState({ loading: true, data: null, error: '' });

  useEffect(() => {
    if (!sessionId) { setState({ loading: false, data: null, error: 'Invalid session.' }); return; }
    api.get(`/payment/verify-session?session_id=${sessionId}`)
      .then(({ data }) => setState({ loading: false, data, error: '' }))
      .catch(err => setState({ loading: false, data: null, error: err.response?.data?.message || 'Verification failed.' }));
  }, [sessionId]);

  // const handlePaymentAction = async () => {
  //   try {
  //     const response = await api.get(`/payment/status/${sessionId}`);

  //     const result = await response.data;

  //     // Send payment status to Flutter
  //     if (window.PaymentChannel) {
  //       window.PaymentChannel.postMessage(
  //         JSON.stringify({
  //           action: "PAYMENT_STATUS",
  //           status: result.status
  //         })
  //       );
  //     } 
  //   } catch (error) {
  //     console.error("Payment status error:", error);
  //   }
  // };

  const { loading, data, error } = state;

  return (
    <div style={s.page}>
      <div style={s.card}>
        {loading && <p style={s.info}>Verifying your payment…</p>}

        {error && (
          <>
            <div style={s.iconWrap}>
              <span style={{ ...s.icon, background: '#fee2e2', color: '#dc2626' }}>✕</span>
            </div>
            <h2 style={s.title}>Verification Failed</h2>
            <p style={s.sub}>{error}</p>
            {/* <button style={s.btn}>Go Home</button> */}
          </>
        )}

        {!loading && data && (
          <>
            {/* Success icon */}
            <div style={s.iconWrap}>
              <span style={{ ...s.icon, background: '#dcfce7', color: '#16a34a' }}>✓</span>
            </div>
            <h2 style={s.title}>Payment Successful!</h2>
            <p style={s.sub}>Thank you for subscribing! Your plan has been activated successfully.
              To return to the application, please refresh the page or click the ✕ (Close) button.
            </p>

            {/* Invoice box */}
            <div style={s.invoice}>
              <div style={s.invoiceHeader}>
                <span style={s.invoiceLabel}>Receipt</span>
                <span style={s.invoiceId}>#{sessionId?.slice(-12).toUpperCase()}</span>
              </div>

              <div style={s.row}>
                <span style={s.rowLabel}>Customer</span>
                <span style={s.rowVal}>{data.user?.name || '—'}</span>
              </div>
              <div style={s.row}>
                <span style={s.rowLabel}>Email</span>
                <span style={s.rowVal}>{data.user?.email || '—'}</span>
              </div>
              <div style={s.divider} />
              <div style={s.row}>
                <span style={s.rowLabel}>Plan</span>
                <span style={s.rowVal}>{data.plan?.name || '—'}</span>
              </div>
              {data.plan?.description && (
                <div style={s.row}>
                  <span style={s.rowLabel}>Description</span>
                  <span style={s.rowVal}>{data.plan.description}</span>
                </div>
              )}
              <div style={s.divider} />
              <div style={{ ...s.row, fontWeight: 700, fontSize: 16 }}>
                <span style={s.rowLabel}>Amount Paid</span>
                <span style={{ color: '#16a34a' }}>{data.currency} {data.amount}</span>
              </div>
              <div style={s.row}>
                <span style={s.rowLabel}>Status</span>
                <span style={s.badge}>Paid</span>
              </div>
            </div>

            {/* <button style={s.btn} onClick={() => handlePaymentAction()}>Back to Home</button> */}
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page:          { minHeight: '100vh', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: "'Segoe UI', sans-serif" },
  card:          { background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '40px 36px', width: '100%', maxWidth: 480, textAlign: 'center' },
  iconWrap:      { display: 'flex', justifyContent: 'center', marginBottom: 16 },
  icon:          { width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700 },
  title:         { fontSize: 22, fontWeight: 700, color: '#111827', margin: '0 0 8px' },
  sub:           { fontSize: 14, color: '#6b7280', marginBottom: 24 },
  info:          { color: '#6b7280', fontSize: 15 },
  invoice:       { background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '20px 20px', marginBottom: 24, textAlign: 'left' },
  invoiceHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  invoiceLabel:  { fontSize: 13, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5 },
  invoiceId:    { fontSize: 12, color: '#9ca3af', fontFamily: 'monospace' },
  row:           { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', fontSize: 14 },
  rowLabel:      { color: '#6b7280' },
  rowVal:        { color: '#111827', fontWeight: 500, maxWidth: 260, textAlign: 'right', wordBreak: 'break-all' },
  divider:       { borderTop: '1px solid #e5e7eb', margin: '8px 0' },
  badge:         { background: '#dcfce7', color: '#16a34a', padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600 },
  btn:           { padding: '12px 32px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', width: '100%' },
};
